import { PRODUCTS_COMPARE_LISTS, SEND_PRODUCTS_COMPARE_LIST_ACTION } from './ducks/actions';

export { productsCompareListsReducer } from './ducks/reducer';
export { watchCompareListActions, fetchCompareListsOnServer } from './ducks/products-compare';

export const productsCompareListsActions = {
  PRODUCTS_COMPARE_LISTS,
  SEND_PRODUCTS_COMPARE_LIST_ACTION,
};

export * from './ducks/selectors';
export * from './types';
